function preload() {
  /* Баннер Куки */
  function setBannerCookie() {
    const banner = document?.querySelector('.cookieBanner');

    setTimeout(() => {
      banner?.classList.add('cookieBanner-active');
      if (document.cookie.indexOf('bcslcook') != -1) {
        banner.classList.remove('cookieBanner-active');
      }
    }, 100);

    if (banner) {
      const button = banner.querySelector('.cookieBanner__btn');
      button.addEventListener('click', () => {
        banner?.classList.remove('cookieBanner-active');
        document.cookie = 'bcslcook=true; max-age=2592000; path=/';
      });
    }
  }

  setBannerCookie();

  // -----------------------------------------------------
  // -----------------    mobileBurger    --------------------
  // -----------------------------------------------------

  (function mobileBurger() {
    const btn_hamburger = document.querySelector('.burger-btn'),
      menu_hamburger = document.querySelector('.header-popup'),
      html = document.documentElement;

    btn_hamburger?.addEventListener('click', (event) => {
      if (btn_hamburger.classList.contains('active-burger')) {
        btn_hamburger.classList.remove('active-burger');
        menu_hamburger.classList.remove('active-menu');
        html.style.overflow = 'visible';
      } else {
        btn_hamburger.classList.add('active-burger');
        menu_hamburger.classList.add('active-menu');
        html.style.overflow = 'hidden';
      }
      event.stopPropagation();
    });

    document.addEventListener('click', (event) => {
      let target = event.target;

      if (target.classList.contains('header__link')) {
        btn_hamburger.classList.remove('active-burger');
        menu_hamburger.classList.remove('active-menu');
        html.style.overflow = 'visible';
      }
    });
  })();

  // -----------------------------------------------------
  // ----------------- purposeButtonCta  -------------------
  // -----------------------------------------------------

  (function purposeButtonCta() {
    const buttons = document.querySelectorAll('.cta-click');

    buttons.forEach((it) => {
      it.addEventListener('click', (e) => {
        e.preventDefault(); 

        if (typeof gtag !== 'undefined') {
          gtag('event', 'click_cta');
        }
        if (typeof ym !== 'undefined') {
          ym(110224245, 'reachGoal', 'click_cta');
        }
      });
    });
  })();

  // -----------------------------------------------------
  // ----------------- driveScrollTo  -------------------
  // -----------------------------------------------------

  (function driveScrollTo() {
    const anchors = document.querySelectorAll('a[href*="#"]');
    if (anchors.length === 0) return;

    // Оптимизация: Используем функцию для очистки хэша
    const clearHash = () => {
      if (window.history && window.history.replaceState) {
        const cleanUrl = window.location.href.split('#')[0];
        window.history.replaceState({}, document.title, cleanUrl);
      } else {
        window.location.hash = '';
      }
    };

    // Оптимизация: Обработчик клика
    const handleAnchorClick = (e) => {
      const blockID = e.currentTarget.getAttribute('href')?.substring(1);

      document.getElementById(blockID)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      setTimeout(clearHash, 1);
    };

    // Применяем обработчик ко всем якорям
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    // Обрабатываем загрузку с хэшем
    if (window.location.hash) {
      setTimeout(clearHash, 1);
    }
  })();
}

document.addEventListener('DOMContentLoaded', () => {
  preload();
});
